import React from 'react';
import { ClientGrid } from '@/clients/list/components/ClientGrid';
import { ClientDashboardItem } from '@/types/client';
import { PaginationInfo } from '@/types/common';
import type { ClientsListStatus } from '@/clients/list/components/ClientsTabEmptyState';

interface ClientsContentProps {
  clients: ClientDashboardItem[];
  pagination: PaginationInfo;
  currentPage: number;
  /** While the client list request is in flight (disables pagination controls). */
  listLoading?: boolean;
  hasAnyClients: boolean;
  clientStatus: ClientsListStatus;
  hasActiveFilters: boolean;
  statusTotals: {
    all?: number;
    active: number;
    suspended: number;
    drafts?: number;
    pendingDeletion?: number;
  };
  onAddClient: () => void;
  onReactivateClient: (clientId: string) => void;
  onSuspendClient: (clientId: string) => void;
  onDeleteClient?: (client: ClientDashboardItem) => void;
  currentStatus: "active" | "suspended" | "draft" | "pending_deletion";
  onPageChange: (page: number) => void;
  onCardClick?: (clientId: string) => void;
  onOpenPanel?: (clientId: string) => void;
  onScheduleClient?: (client: ClientDashboardItem) => void;
  onDraftClick?: (draftId: string) => void;
  onDeleteDraft?: (draftId: string) => void;
  deletingDraftId?: string | null;
  viewMode?: 'grid' | 'list';
  highlightedClientId?: string | null;
}

export const ClientsContent: React.FC<ClientsContentProps> = ({
  clients,
  pagination,
  currentPage,
  listLoading = false,
  hasAnyClients,
  clientStatus,
  hasActiveFilters,
  statusTotals,
  onAddClient,
  onReactivateClient,
  onSuspendClient,
  onDeleteClient,
  currentStatus,
  onPageChange,
  onCardClick,
  onOpenPanel,
  onScheduleClient,
  onDraftClick,
  onDeleteDraft,
  deletingDraftId = null,
  viewMode = 'grid',
  highlightedClientId = null,
}) => {
  return (
    <div>
      <ClientGrid
        clients={clients}
        hasAnyClients={hasAnyClients}
        clientStatus={clientStatus}
        hasActiveFilters={hasActiveFilters}
        statusTotals={statusTotals}
        onAddClient={onAddClient}
        onReactivateClient={onReactivateClient}
        onSuspendClient={onSuspendClient}
        onDeleteClient={onDeleteClient}
        currentStatus={currentStatus}
        pagination={pagination}
        currentPage={currentPage}
        listLoading={listLoading}
        onPageChange={onPageChange}
        onCardClick={onCardClick}
        onOpenPanel={onOpenPanel}
        onScheduleClient={onScheduleClient}
        onDraftClick={onDraftClick}
        onDeleteDraft={onDeleteDraft}
        deletingDraftId={deletingDraftId}
        viewMode={viewMode}
        highlightedClientId={highlightedClientId}
      />
    </div>
  );
};
